import { Component } from 'react'
import { getDatePublishFormat, getHTMLFormatedData, isEmptyList, isEmptyObject, seoSetTitleAndDescription } from '../../utils/UtilityFunctions';
import cx from 'classnames';
import classes from './UseCase.module.css'
import globalClasses from '../../App.module.css';
import { USECASE_CONTENT_TYPE, CONTENT_ALIGN, USECASES_BREAKPOINT } from './UseCase.utils';
import {MdChevronLeft} from 'react-icons/md'
import axios from 'axios';
import { ROUTE_CONSTANTS } from '../../routes/RouteConstants';
import Loader from '../../components/loader/Loader';
import { GET_USECASE } from '../../urls/Urls';
import { EMPTY_STRING, PAGE_TITLE, THEME } from '../../utils/Constants';
import ContactBanner from '../../components/contact_banner/ContactBanner';
import NoData from '../../components/no_data/NoData';
import CustomCarousel from '../../components/ui_elements/custom_carousel/CustomCarousel';
import UseCaseCard from '../../components/whitepaper_cards/WhitePaperCard';
import ComponentHelmet from '../../components/component_helmet/ComponentHelmet';

class SingleUseCase extends Component{
    state = {
        useCaseDetails : {}, isLoading:true, relatedUseCases : []
    }

    getUsecaseDetails = () => {
        let usecaseID = this.props.match?.params?.usecaseID
        let requestURL = GET_USECASE + "?usecase_id=" + usecaseID
        
        axios.get(requestURL)
            .then((response) => {
                let useCaseDetails = Object.assign({},(response?.data?.usecase_details || {}))
                let relatedUseCases = Object.assign([],(response?.data?.realted_usecase_details || []))
                this.setState({
                    useCaseDetails,
                    relatedUseCases,
                    isLoading : false
                })
            })
            .catch((err) => {
                this.setState({
                    isLoading : false,
                    useCaseDetails: {},
                    relatedUseCases : []
                })
            })
    }

    componentDidMount = () => {
        window.scrollTo(0,0);
        // seoSetTitleAndDescription(PAGE_TITLE.USE_CASE.TITLE,PAGE_TITLE.USE_CASE.DESCRIPTION)
        this.getUsecaseDetails()
    }
    
    componentWillUnmount = () => {
        seoSetTitleAndDescription()
    }

    onClickBacktoUseCases = () => {
        this.props.history.push({pathname : ROUTE_CONSTANTS.USECASE})
    }

    render(){
        const {isAuthenticated, isSubscribedUser} = this.props;
        const { useCaseDetails, relatedUseCases, isLoading } = this.state;

        let bannerComponent = null;
        let contentComponent = null;
        let relatedUseCasesComponent = null;
        let loaderComponent = null;
        let bodyComponent = null;
        let contactBannerComponent = null;

        let backButtonClass = cx([classes.BackLink,globalClasses.PointerCursor])

        if(!isEmptyObject(useCaseDetails)){
            bannerComponent = (
                <div className='container py-4 py-md-5'>
                    <div className={cx(['row flex-wrap'])}>
                        <div className='col-12 mb-3'>
                            <span className={backButtonClass} onClick={this.onClickBacktoUseCases}>
                                <MdChevronLeft style={{marginBottom: '3px'}}/>{"Back to all use cases"}
                            </span>
                        </div>
                        <div className={cx(['row flex-wrap align-items-center'])}>
                            <div className='col-12 col-md-7'>
                                <h1 className={classes.BlogTitle}>{useCaseDetails.title}</h1>
                                <p className={classes.BlogParagraph}>{useCaseDetails.subtitle}</p>
                            </div>
                            <div className='col-12 col-md-5'>
                                <img className={classes.BlogCoverImage} src={process.env.REACT_APP_S3_PUBLIC_BUCKET_BASE_URL+"/"+useCaseDetails.cover} alt={'UseCaseImage'} />
                            </div>
                        </div>
                    </div>
                </div>
            )
            if(!isEmptyList(useCaseDetails.contents)){
                contentComponent = (
                    <div className='col-12'>
                        {
                            useCaseDetails.contents.map((item) => {
                                let type = item.type
                                let content = item.content
                                switch(type){
                                    case USECASE_CONTENT_TYPE.SUBHEAD : return(
                                        <h2 className={classes.BlogSubHeading}>{getHTMLFormatedData(content.value,content.meta)}</h2>
                                    )
                                    case USECASE_CONTENT_TYPE.PARA : return(
                                        <p className={classes.BlogParagraph}>{getHTMLFormatedData(content.value,content.meta)}</p>
                                    )
                                    case USECASE_CONTENT_TYPE.QUOTE : return(
                                        <p className={classes.BlogQuote} style={content.alignment===CONTENT_ALIGN.LEFT? { textAlign: "left",  } : content.alignment===CONTENT_ALIGN.RIGHT? { textAlign: "right" } : content.alignment===CONTENT_ALIGN.JUSTIFY? { textAlign: "justify" } : { textAlign: "center" }}>{content.value}</p>
                                    )
                                    case USECASE_CONTENT_TYPE.IMAGE : return(
                                        <img className={classes.BlogImage} src={process.env.REACT_APP_S3_PUBLIC_BUCKET_BASE_URL+"/"+content.value} alt={'UseCaseImage'} />
                                    )
                                    case USECASE_CONTENT_TYPE.FIGURE : return(
                                        <figure>
                                            <img className={classes.BlogImage} src={process.env.REACT_APP_S3_PUBLIC_BUCKET_BASE_URL+"/"+(content[0].value)} alt={'UseCaseImage'} />
                                            <figcaption className={classes.FigCaption}>{getHTMLFormatedData(content[1].value,content[1].meta)}</figcaption>
                                        </figure>
                                    )
                                    case USECASE_CONTENT_TYPE.UNORDER_LIST : return(
                                        <ul className={classes.BlogList}>
                                            {
                                                content.map((listItem,index) => {
                                                    return(
                                                        <li key={index}>{getHTMLFormatedData(listItem.value,listItem.meta)}</li>
                                                    )
                                                })
                                            }
                                        </ul>
                                    )
                                    case USECASE_CONTENT_TYPE.ORDER_LIST : return(
                                        <ol className={classes.BlogList}>
                                            {
                                                content.map((listItem,index) => {
                                                    return(
                                                        <li key={index}>{getHTMLFormatedData(listItem.value,listItem.meta)}</li>
                                                    )
                                                })
                                            }
                                        </ol>
                                    )
                                    case USECASE_CONTENT_TYPE.CUSTOM_LIST_CHALLENGE : 
                                    case USECASE_CONTENT_TYPE.CUSTOM_LIST_SOLUTION : 
                                    case USECASE_CONTENT_TYPE.CUSTOM_LIST_BENEFIT :
                                        let customListClass = EMPTY_STRING 
                                        if(type===USECASE_CONTENT_TYPE.CUSTOM_LIST_CHALLENGE){
                                            customListClass = classes.Challenges
                                        }
                                        if(type===USECASE_CONTENT_TYPE.CUSTOM_LIST_SOLUTION){
                                            customListClass = classes.Solutions
                                        }
                                        if(type===USECASE_CONTENT_TYPE.CUSTOM_LIST_BENEFIT){
                                            customListClass = classes.Benefits
                                        }
                                        return(
                                            <ul className={cx(classes.CustomList,customListClass)}>
                                                {
                                                    content.map((listItem,index) => {
                                                        return(
                                                            <li key={index}>{getHTMLFormatedData(listItem.value,listItem.meta)}</li>
                                                        )
                                                    })
                                                }
                                            </ul>
                                        )
                                    default : return null
                                }
                            })
                        }
                    </div>
                )
            }

            if(!isEmptyList(relatedUseCases)){
                relatedUseCasesComponent = (
                    <div className={"pt-4 pb-5"}>
                        <div className={"d-flex flex-column px-4"}>
                            <h3 className={classes.RelatedUseCasesTitle}>{"Related Use Cases"}</h3>
                            <div className={"col-12 py-4"}>
                                <CustomCarousel
                                    carouselBreakpoints={USECASES_BREAKPOINT}
                                    itemsToShow={4}
                                    enableArrows={true}
                                    itemsToScroll={1}
                                    transitionDuration={1200}
                                    enablePagination={false}
                                    focusOnSelect={true}
                                    enableAutoPlay={true}
                                >
                                    {
                                        relatedUseCases.map((usecase,index) => {
                                            return (
                                                <a key={index} className={cx("col-12 my-3 px-2",classes.AnchorCardTag)} href={ROUTE_CONSTANTS.USECASE+"/"+usecase.id}>
                                                    <UseCaseCard
                                                        containerClass = {"col-12"}
                                                        title = {usecase.title}
                                                        image = {process.env.REACT_APP_S3_PUBLIC_BUCKET_BASE_URL+"/"+usecase.cover}
                                                        itemDetails={usecase}
                                                        isUseCase = {true}
                                                    />
                                                </a>
                                            )
                                        })
                                    }
                                </CustomCarousel>
                            </div>
                        </div>
                    </div>
                )
            }

        } else {
            contentComponent  = (
                <div className="col-12">
                    <NoData
                        mainText={"No Use-Cases Found"} 
                        subText={"Currently we have't published the usecase in our page, please reach out to us if you need to publish your usecase."}
                    />
                </div>
            )
        }

        if(isLoading){
            loaderComponent = (
                <Loader
                    containerClass = {globalClasses.AbsoluteComponentLoader}
                />
            )
        }

        contactBannerComponent = (
            <ContactBanner 
                isAuthenticated = {isAuthenticated}
                isSubscribedUser={isSubscribedUser}
                theme = {THEME.LIGHT_BLUE_SHADES}
            />
        )


        bodyComponent = (
            <div className='w-100 position-relative'>
                {loaderComponent}
                <div className='container'>
                    {contentComponent}
                    {relatedUseCasesComponent}
                </div>
                {contactBannerComponent}
            </div>
        )
        
        return(
            <div>
                <ComponentHelmet
                    title={[PAGE_TITLE.USE_CASE.INDIVIDUAL_TITLE,useCaseDetails.title]}
                    description={useCaseDetails.subtitle}
                    path={process.env.REACT_APP_DOMAIN_URL + window.location.pathname}
                />
                {bannerComponent}
                {bodyComponent}
            </div>
        )
    }
}

export default SingleUseCase;